// extracted by mini-css-extract-plugin
export default {"wrapper":"b3-z","play":"c3-z"};